package uz.ferro.shop.document

import kotlinx.serialization.Serializable

@Serializable
data class TextSpan(
    val isBold: Boolean? = null,
    val isItalic: Boolean? = null,
    val color: String? = null,
    val text: String?
)